const navbar = document.querySelector(`.navbar`);
const toggle_container = document.querySelector(`.toggle-container`);
const navbar_dropdown = document.querySelector(`.navbar-collapse.collapse`);

if (navbar_dropdown) {
  toggle_container.addEventListener(`click`, function () {
    if (navbar_dropdown.classList.contains(`show`)) {
      navbar.classList.remove(`padding-fix`);
    } else {
      navbar.classList.add(`padding-fix`);
    }
  });
}
